import { useMemo, cloneElement } from 'react';
import { scrollTo } from 'utils/utils';
import {
	BiographyCard,
	CarouselCard,
	QuoteCard,
	LinkCard,
	EpisodeCard,
	VoteResultsCard,
} from '../../components';
import {
	useGlobalSettings,
	useUiSettings,
} from '../../hooks/useGlobalSettings';

import { checkFetchError } from '../../utils/checkFetchError';

const cardMapper = (card, key, uiParams) => {
	const {
		show_apl_bio,
		show_apl_news,
		show_apl_quotes,
		show_apl_media,
		show_apl_episode_history,
	} = uiParams;

	if (Array.isArray(card) && card.length) {
		const [id, component] = cardMapper(card[0], key, uiParams);
		if (id === 'media')
			return show_apl_media
				? [id, <LinkCard id={id} key={key} tiles={card} />]
				: [];
		else if (id === 'apl_past_episodes')
			return show_apl_episode_history
				? [id, <EpisodeCard id={'apl_' + id} key={key} tiles={card} />]
				: [];
		return [
			id,
			card.length === 1 ? (
				component
			) : (
				<CarouselCard id={id} key={key}>
					{card
						// .sort((a,b) => {
						// 	console.log(61,a.props.quote_text.length, b.props.quote_text.length,a.props.quote_text.length > b.props.quote_text.length)
						// 	return a.props.quote_text.length > b.props.quote_text.length;
						// })
						.map((c, k) => cardMapper(c, k, uiParams).pop())}
				</CarouselCard>
			),
		];
	}
	const { type, props } = card;
	switch (type) {
		case 'BiographyCard':
			return show_apl_bio
				? ['biography', <BiographyCard key={key} {...props} />]
				: [];
		// news disabled per Flo, for now.
		// case 'TopicCard':
		// 	return ['news', <TopicCard key={key} {...props} />];
		case 'VoteResultsCard':
			return show_apl_news
				? ['news', <VoteResultsCard key={key} {...props} />]
				: [];
		case 'QuoteCard':
		case 'TipCard':
			return show_apl_quotes
				? ['quotes', <QuoteCard key={key} {...props} type={type} />]
				: [];
		case 'ThumbnailTile':
			return ['media', <LinkCard key={key} tiles={[card]} />];
		case 'EpisodeTile':
			return [
				'apl_past_episodes',
				<EpisodeCard key={key} tiles={[card]} />,
			];
		default:
			console.error('Unsupported card type:', type, 'in card', card);
			return [];
	}
};

const fetchEpisodeMoreInfo = async ({
	companyID,
	videoID,
	uiParams,
	from_shared_link,
}) =>
	fetch(
		`/api/getEpisodeMoreInfo?${new URLSearchParams({
			companyID,
			videoID,
			from_shared_link,
			// language,
		})}`
	)
		.then(checkFetchError)
		.then((data) =>
			data.content
				.map((card, index) => {
					const [id, component] = cardMapper(card, index, uiParams);
					return component && cloneElement(component, { id });
				})
				.filter(Boolean)
		);

export const PlayerAPL = ({ content, setContent }) => {
	const {
		video: { videoID, language },
		userData: { companyID },
		from_shared_link,
	} = useGlobalSettings();
	const uiParams = useUiSettings();

	useMemo(() => {
		fetchEpisodeMoreInfo({
			companyID,
			videoID,
			language,
			uiParams,
			from_shared_link,
		})
			.then(setContent)
			.then(() => {
				window.location.hash.length > 0 &&
					scrollTo(window.location.hash.slice(1));
			});
	}, [companyID, videoID, language, uiParams, from_shared_link, setContent]);

	return content;
};
